import { useMutation, useQueryClient } from '@tanstack/react-query';
import deletePartner from '@/API/Partner/deletePartner';
import { toast } from 'react-toastify';

const useDeletePartner = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (partnerId) => deletePartner(partnerId),
        onSuccess: () => {
            // Invalidate and refetch partners list
            queryClient.invalidateQueries({ queryKey: ['partners'] });
            toast.success('Partner deleted successfully');
        },
        onError: (error) => {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Failed to delete partner';
            toast.error(errorMessage);
        },
    });
};

export default useDeletePartner;
